import { render, staticRenderFns } from "./DeadlinesHoldLogTabs.vue?vue&type=template&id=24b82250&scoped=true"
import script from "./DeadlinesHoldLogTabs.vue?vue&type=script&lang=js"
export * from "./DeadlinesHoldLogTabs.vue?vue&type=script&lang=js"
import style0 from "./DeadlinesHoldLogTabs.vue?vue&type=style&index=0&id=24b82250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b82250",
  null
  
)

export default component.exports